import { useEffect, useState } from 'react';
import { Col, Spinner } from 'reactstrap';
import { H3 } from '../../../../AbstractElements';
import BootstrapTable from 'react-bootstrap-table-next';
import { useGetRequestQuery } from '../../../../Hooks/useGetRequestQuery';
import { getAssetsPropertyByClientIdService } from '../../../../Services/PublicPageServices';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../ReduxToolkit/Store';
import { useNavigate } from 'react-router-dom';
 
export default function InvestmentProperty() {
    const [assetsPropertyData, setAssetsPropertyData] = useState([]);
    const userData = useSelector((state: RootState) => state.auth);
    const navigate = useNavigate(); 
    const {
        data: assetsProperty,
        refetch: refetchAssetsProperty,
        isLoading: assetsPropertyLoading,
        isError: assetsPropertyIsError,
    } = useGetRequestQuery(
        ['getAssetsPropertyByClientId', userData?.nameidentifier],
        () => getAssetsPropertyByClientIdService(userData?.nameidentifier as any),
        {
            enabled: true,
        }
    );

    useEffect(() => {
        if (assetsProperty?.data && !assetsPropertyIsError && !assetsPropertyLoading) {
            const filteredData = assetsProperty.data.filter((property: any) => property.propertyUse !== "Owner Occupied");
            setAssetsPropertyData(filteredData);
        }
    }, [assetsProperty, assetsPropertyIsError, assetsPropertyLoading]);

    const columns: any = [
        {
            dataField: "actions",
            text: "Action",
            formatter: (_: unknown, row: any) => (
                <button
                    style={{
                        backgroundColor: 'green',
                        color: 'white',
                        border: 'none',
                        padding: '5px 10px',
                        cursor: 'pointer',
                    }}
                    onClick={() => navigate(`/EditInvestmentProperty/${row.id}`, { state: { homeAddress: row.homeAddress } })} 
                >
                    Edit
                </button>
            ),
            headerStyle: { width: "5rem", color: "#0000ff" }, // Blue header
        },
        {
            dataField: "propertyType",
            text: "Type",
            headerStyle: { width: "7rem", color: "#0000ff" },
        },
        {
            dataField: "homeAddress",
            text: "Location",
            headerStyle: { width: "20rem", color: "#0000ff" },
        },
        {
            dataField: "propertyUse",
            text: "Usage",
            headerStyle: { width: "9rem", color: "#0000ff" },
        },
        {
            dataField: "datePurchased",
            text: "Acquired",
            formatter: (cell: string) => new Date(cell).toLocaleDateString("en-GB"),
            headerStyle: { width: "8rem", color: "#0000ff" },
        },
        {
            dataField: "estimatedValue",
            text: "Value",
            headerStyle: { width: "6rem", color: "#0000ff" },
        },
        {
            dataField: "currentMortgage",
            text: "Debt",
            headerStyle: { width: "6rem", color: "#0000ff" },
        },
        {
            dataField: "rentalIncome",
            text: "Rent Mthly",
            headerStyle: { width: "9rem", color: "#0000ff" },
        },
        {
            dataField: "lendersName",
            text: "Lender",
            headerStyle: { color: "#0000ff" },
        },
        {
            dataField: "loanDetailsMonthlyRepayment",
            text: "Repay Mthly",
            headerStyle: { width: "8rem", color: "#0000ff" },
        },
        {
            dataField: "interestRate",
            text: "%",
            headerStyle: { width: "4rem", color: "#0000ff" },
        },
        {
            dataField: "propertyLVR1",
            text: "LVR",
            formatter: (cell?: number) => cell ?? 0,
            headerStyle: { width: "4rem", color: "#0000ff" },
        },
        {
            dataField: "propertyEquity1",
            text: "Equity",
            formatter: (cell?: number) => cell ?? 0,
            headerStyle: { color: "#0000ff" },
        }
    ];

    return (
        <div className='container-fluid'>
            <div className="table-responsive h-100 py-4">
                <section className='bg-white'>
                    <div className="assets-scrollable-table-container">
                        <table className="scrollable-table" style={{ marginLeft: '1%', marginTop: '3%' }}>
                            <div className="d-flex align-items-center">
                                <Col xs={12} className='d-flex'>
                                    <H3 className="heading-color f-w-900 text-left my-2">Investment Property</H3>
                                </Col>
                            </div>
                            {assetsPropertyLoading ? (
                                <div
                                    style={{
                                        borderRadius: '8px',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        padding: '15px',
                                        backgroundColor: '#fff',
                                        textAlign: 'center',
                                    }}
                                    className='mt-4'
                                >
                                    <Spinner color="primary" />
                                </div>
                            ) : assetsPropertyData.length !== 0 ? (
                                <div
                                    style={{
                                        borderRadius: '8px',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        padding: '5px',
                                        backgroundColor: '#fff',
                                        overflowX: 'auto',
                                        width: '100%',
                                    }}
                                    className='mt-4'
                                >
                                    <div style={{ minWidth: 'max-content' }}> {/* Ensures table does not shrink */}
                                        <BootstrapTable
                                            keyField="id"
                                            data={[...assetsPropertyData].sort((a: any, b) => (a.propertyUse === "Owner Occupied" ? -1 : 1))}
                                            columns={columns}
                                            bordered={false}
                                            wrapperClasses="table-responsive"
                                            rowStyle={(row) => ({
                                                fontWeight: row.propertyUse === "Owner Occupied" ? "bold" : "normal",
                                            })}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div
                                    style={{
                                        borderRadius: '8px',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        padding: '15px',
                                        backgroundColor: '#fff',
                                        textAlign: 'center',
                                    }}
                                    className='mt-4'
                                >
                                    <h6>No property has been added yet.</h6>
                                </div>
                            )}
                        </table>
                    </div>
                </section>
            </div>
        </div>
    );
}